import {Injectable} from '@angular/core';

@Injectable()
export class MenuProvider {

  constructor() {
  }

  getSideMenus() {

    return [
      {title: 'Home', icon: 'home', page: 'HomePage'},
      // {
      //   title: 'Faturamento',
      //   icon: 'book',
      //   subPages: [{
      //     title: 'DashBoard',
      //     icon: 'podium',
      //     page: 'FatDashboardPage',
      //   }, {
      //     title: 'Detalhado',
      //     icon: 'list-box',
      //     page: 'FatResumidoPage',
      //   }]
      // },
      {title: 'Clientes', icon: 'people', page: 'ClientePage'},
      {title: 'Pedidos', icon: 'cart', page: 'PedidosPage'},
      {title: 'Alertas', icon: 'alert', page: 'AlertasPage'},
      // {title: 'Marc. Blocos', icon: 'cube', page: 'MarcBlocosPage'},
      // {
      //   title: 'Relatórios',
      //   icon: 'albums',
      //   subPages: [{
      //     title: 'Curva ABC FAT',
      //     icon: 'analytics',
      //     page: 'CurvaAbcFatPage',
      //   }]
      // },
      // {
      //   title: 'Estoque',
      //   icon: 'browsers',
      //   subPages: [{
      //     title: 'Top Vendidos',
      //     page: 'TopvendidosPage',
      //   }, {
      //     title: 'Top Produzidos',
      //     page: 'TopproduzidosPage',
      //   }, {
      //     title: 'Estoque de Pedidos',
      //     page: 'EstoquepedPage',
      //   }, {
      //     title: 'Consulta de Lotes',
      //     page: 'ConsultaLotesPage',
      //   }, {
      //     title: 'Consulta de Produtos',
      //     page: 'ConsultaEstProdutosPage',
      //   }]
      // },
      {title: 'Releases', icon: 'contract', page: 'ReleasePage'},
      // {
      //   title: 'Estoque',
      //   icon: 'archive',
      //   subPages: [{
      //     title: 'Top Vendidos',
      //     page: 'TopvendidosPage',
      //   }, {
      //     title: 'Top Produzidos',
      //     page: 'TopproduzidosPage',
      //   }, {
      //     title: 'Estoque de Pedidos',
      //     page: 'EstoquepedPage',
      //   }, {
      //     title: 'Consulta de Lotes',
      //     page: 'ConsultaLotesPage',
      //   }, {
      //     title: 'Consulta de Produtos',
      //     page: 'ConsultaEstProdutosPage',
      //   }]
      // },
      // {
      //   title: 'Admin',
      //   icon: 'build',
      //   subPages: [{
      //     title: 'Usuários',
      //     icon: 'person',
      //     page: '',
      //   }, {
      //     title: 'Grupos',
      //     icon: 'people',
      //     page: '',
      //   }, {
      //     title: 'Permissões',
      //     icon: 'key',
      //     page: '',
      //   }, {
      //     title: 'Empresas / Filiais',
      //     icon: 'albums',
      //     page: '',
      //   }]
      // },
      {title: 'Sair', icon: 'log-out', page: 'exitPage'}];
  }
}



// WEBPACK FOOTER //
// ./src/providers/menu/menu.ts